import index from '../objects/home/index'

index()

// Homepage JS for US market

document.addEventListener('DOMContentLoaded', function() {
  // Horizontal scroll hint for recommended products
  var recList = document.querySelector('.home-recommended__list');
  if (recList && recList.scrollWidth > recList.clientWidth) {
    recList.classList.add('is-scrollable');
  }

  // Fade-in animation for banner and text-image rows
  var fadeEls = document.querySelectorAll('.home-banner, .home-text-image__row');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    fadeEls.forEach(function(el) { observer.observe(el); });
  } else {
    // Fallback: show all
    fadeEls.forEach(function(el) { el.classList.add('is-visible'); });
  }
});
